import React, { Component } from 'react';
import Outbox from './Outbox.js';

export default class OutboxMemo extends Component {
  render() {
    return (
      <Outbox type='TNDE_MEMO'/>
    );
  }
}
